import {IAccConfigInvoice} from "../../model/respone/category/IAccConfigInvoice";
import {apiClient} from "../apiClient";

export const CONFIG_INVOICE_ENDPOINT = "config-invoice";
export const configInvoiceApi = {
    SelectAll: () => apiClient.get(`${CONFIG_INVOICE_ENDPOINT}`),
    Insert: (payload: IAccConfigInvoice) =>
        apiClient.post(`${CONFIG_INVOICE_ENDPOINT}`, payload),
    Update: (payload: IAccConfigInvoice) =>
        apiClient.put(`${CONFIG_INVOICE_ENDPOINT}`, payload),
    Delete: (id: number) => apiClient.delete(`${CONFIG_INVOICE_ENDPOINT}/${id}`),
    DeleteMany: (ids: number[]) =>
        apiClient.post(`${CONFIG_INVOICE_ENDPOINT}/delete-many`, ids),
};
